$tooltip_background-color: snk-color(primary, base);
$triangle_small-side: 0.4375rem;
$triangle_large-side: 0.8125rem;

ds-tooltip {
  & > [slot] {
    display: none;
  }
}

.ds-tooltip {
  display: inline-flex;
  position: relative;
  white-space: normal;
  width: min-content;
  align-content: center;
  justify-content: center;

  &__content {
    width: 100%;
    & > span {
      white-space: nowrap;
    }

  }

  & [slot="message"] {
    display: none;
    position: absolute;
    padding: 0.75rem;
    line-height: 1.3rem;
    background-color: $tooltip_background-color;
    color: #000;
    font-size: 1rem;
    z-index: 1000;
    width: 220px;
    font-weight: 700;
    border-radius: 0.5rem;
    letter-spacing: 0.28px;
    text-align: left;
  }

  &.--top {
    & [slot="message"] {
      bottom: calc(100% + 10px);
      left: 50%;
      transform: translateX(-50%);
    }
  }
  &.--top-left {
    & [slot="message"] {
      bottom: calc(100% + 10px);
      left: 50%;
      transform: translateX(-10%);
    }
  }
  &.--top-right {
    & [slot="message"] {
      bottom: calc(100% + 10px);
      left: 50%;
      transform: translateX(-85%);
    }
  }
  &.--bottom {
    & [slot="message"] {
      top: calc(100% + 10px);
      left: 50%;
      transform: translateX(-50%);
    }
  }
  &.--bottom-left {
    & [slot="message"] {
      top: calc(100% + 10px);
      left: 15%;
      transform: translateX(-5%);
    }
  }
  &.--bottom-right {
    & [slot="message"] {
      top: calc(100% + 10px);
      left: 15%;
      transform: translateX(-85%);
    }
  }
  &.--left {
    & [slot="message"] {
      right: calc(100% + 10px);
      top: -50%;
      transform: translateY(-50%);
    }
  }
  &.--right {
    & [slot="message"] {
      left: calc(100% + 10px);
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &.--with-arrow {
    
    /* &.--top {
      &:after {
        top: 0;
        left: 50%;
        transform: translate3d(-50%, -100%, 0) rotate(180deg);
      }
    }
  
    &.--top-left {
      &:after {
        top: 0;
        left: 0;
        transform: translate3d(-20%,-100%, 0) rotate(180deg);
      }
    }
    &.--top-right {
      &:after {
        top: 0;
        right: 0;
        transform: translate3d(20%,-100%, 0) rotate(180deg);
      }
    }
    &.--bottom {
      &:after {
        bottom: 0;
        left: 50%;
        transform: translate3d(-50%, 100%, 0);
      }
    }
    &.--bottom-left {
      &:after {
        bottom: 0;
        left: 0;
        transform: translate3d(-20%, 100%, 0);
      }
    }
    &.--bottom-right {
      &:after {
        bottom: 0;
        right: 0;
        transform: translate3d(20%, 100%, 0);
      }
    }
    &.--left {
      &:after {
        left: 0;
        top: 50%;
        transform: translate3d(-100%, -50%, 0) rotate(90deg);
      }
    }
    &.--right {
      &:after {
        right: 0;
        top: 50%;
        transform: translate3d(100%, -50%, 0) rotate(-90deg);
      }
    } */
  }
  
  &.--is-shown {
    &.--top,
    &.--top-left, 
    &.--top-right, 
    &.--bottom,
    &.--bottom-left, 
    &.--bottom-right, 
    &.--left, 
    &.--right {
      &:after {
        display: block;
      }
    }
    & [slot="message"] {
      display: block;
    }
  }
}

